import React from 'react';
import { StudyGuideLessonDataGrid } from './study-guide-lesson-data-grid';
import { DialogContent, DialogTitle } from '@/components/ui/dialog';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';

export function StudyGuideLessonModal(props) {
  const { data } = props;
  const playful = usePlayfulStudent();

  return (
    <DialogContent size="lg">
      <DialogTitle
        border
        style={playful ? { color: 'var(--color-secondary)' } : undefined}
      >
        Aulas iniciadas
      </DialogTitle>

      <StudyGuideLessonDataGrid
        data={data}
        height={366}
      />
    </DialogContent>
  );
}
